import {createContext, useContext, useEffect, useMemo, useState} from "react";
import Cookies from 'js-cookie';
import {getURL} from "../api/ccn";

const AuthContext = createContext();

export function AuthProvider({children}) {
    const initUser = Cookies.get('user')
    const [user, setUser] = useState(initUser ? JSON.parse(initUser) : null)
    const [ccnUrl, setCCNUrl] = useState(null)

    useEffect(() => {
        // Only call getURL if user is authenticated and has admin/superadmin role
        if (user && (user.role === 'admin' || user.role === 'superadmin')) {
            // Add a small delay to ensure token is properly set
            const timer = setTimeout(() => {
                getURL()
                    .then((res) => {
                        setCCNUrl(res.data?.redirectUrl)
                    })
                    .catch((error) => {
                        console.error('Error fetching CCN URL:', error);
                        // Don't crash the app, just log the error
                    });
            }, 100); // 100ms delay
            
            return () => clearTimeout(timer);
        }
    }, [user]);

    const authContextValue = useMemo(() => ({user, setUser, ccnUrl}), [user, ccnUrl]);

    return (
        <AuthContext.Provider value={authContextValue}>
            {children}
        </AuthContext.Provider>
    )
}

export default function useAuth() {
    return useContext(AuthContext)
}
